import { VehicleQuestionsService } from './../../../vehicle-questions.service';
import { Injectable } from '@angular/core';
import { VehicleStateModel } from '../../../../models/vehicle-state.model';
import { CalculationService } from '../../calculation.service';
import { ConfigurationService } from '../../configuration/configuration.service';
import { CalculationStorageService } from '../../../../../shared/services/calculation-storage.service';
import { VehicleCondition } from '../../../../consts/vehicle-condition.enum';
import { Dictionary } from '../../../../configuration/dictionary';
import { VehicleStateInterface } from '../../../api/sections-api/vehicle-state.interface';
import { VehicleStateEnum } from '../../../../consts/vehicle-state.enum';
import { VehicleQuestionCode } from '../../../../consts/vehicle-question-code.enum';
import { VehicleQuestionAnswer } from '../../../../consts/vehicle-question-answer.enum';
import { Dictionaries, UiConfig } from '../../../../configuration/ui-config';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { AboardImportedEnum } from '../../../../consts/aboard-imported.enum';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class VehicleStateStateService implements VehicleStateInterface {

  damageDescriptionEnabled = false;
  public vehicleCondition = VehicleCondition;
  private dictionaries: Dictionaries;

  constructor(private logicService: CalculationService,
              private configuration: ConfigurationService,
              private storage: CalculationStorageService,
              private vehicleQuestionsService: VehicleQuestionsService) {
    this.dictionaries = this.configuration.uiConfig.dictionaries;
  }

  get vehicleState(): VehicleStateModel {
    return this.logicService.vehicleState;
  }

  get avgMileagePerYearDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.AVG_MILEAGE_PER_YEAR];
    }
    return null;
  }

  get vehicleConditionDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.VEHICLE_CONDITION];
    }
    return null;
  }

  get usageTypeDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.USAGE_TYPE];
    }
    return null;
  }

  get parkingPlaceDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.PARKING_PLACE];
    }
    return null;
  }

  get abroadImportedDictionary(): any {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.ABROAD_IMPORTED];
    }
    return null;
  }

  get isLeasing(): boolean {
    const leasing: VehicleQuestionAnswer = this.vehicleState.questions.filter(question => question.questionCode === VehicleQuestionCode.isLeasing)[0].questionAnswer;
    return leasing === VehicleQuestionAnswer.LEASING_YES;
  }

  get vehicleCountryOfOriginVisible(): boolean {
    return isNotNullOrUndefined(this.vehicleState.abroadImported) && this.vehicleState.abroadImported !== 'ABROAD_IMPORTED_NO';
  }

  changeActualMileage(actualMileage: string): void {
    if (actualMileage.length > 0) {
      this.vehicleState.actualMileage = +actualMileage.replace(/\s/g, '');
    } else {
      delete this.vehicleState.actualMileage;
    }
    this.storage.updateCalculation();
  }

  changeDamageDescription(damageDescription: string): void {
    this.vehicleState.damageDescription = damageDescription;
    this.storage.updateCalculation();
  }

  changeUsageType(usageType: string): void {
    this.vehicleState.usageType = usageType;
    this.storage.updateCalculation();
  }

  changeAvgMileagePerYear(avgMileagePerYear: string): void {
    this.vehicleState.avgMileagePerYear = avgMileagePerYear;
    this.storage.updateCalculation();
  }

  changeVehicleCondition(condition: string): void {
    this.vehicleState.vehicleCondition = condition;
    if (condition === VehicleCondition.NOT_DAMAGED) {
      delete this.vehicleState.damageDescription;
    }
    this.storage.updateCalculation();
  }

  changeParkingPlace(parkingPlace: string): void {
    this.vehicleState.parkingPlace = parkingPlace;
    this.storage.updateCalculation();
  }

  changeCountryOfOrigin(countryOfOrigin: string): void {
    this.vehicleState.countryOfOrigin = countryOfOrigin;
    this.storage.updateCalculation();
  }

  changeIsValidCarInspection(isValidCarInspection: string): void {
    this.vehicleQuestionsService.updateQuestion(this.vehicleState, VehicleStateEnum.IS_VALID_CAR_INSPECTION, isValidCarInspection);
    this.storage.updateCalculation();
  }

  changeIsLeasing(isLeasing: boolean): void {
    this.vehicleQuestionsService.updateQuestion(this.vehicleState, VehicleStateEnum.IS_LEASING, isLeasing);
    this.storage.updateCalculation();
  }

  changeIsAbroad(isAbroad: string): void {
    this.vehicleQuestionsService.updateQuestion(this.vehicleState, VehicleStateEnum.IS_ABROAD, isAbroad);
    this.storage.updateCalculation();
  }

  changeAbroadImported(abroadImported: string): void {
    if (abroadImported === AboardImportedEnum.ABROAD_IMPORTED_NO) {
      delete this.vehicleState.countryOfOrigin;
    }
    this.vehicleState.abroadImported = abroadImported;
    this.storage.updateCalculation();
  }

  changePurchaseYear(purchaseDate: Date): void {
    const purchaseYear = isNotNullOrUndefined(purchaseDate) ? moment(purchaseDate).year() : null;
    this.vehicleState.purchaseYear = purchaseYear;
    this.storage.updateCalculation();
  }

  changePurchaseMonth(purchaseMonth: number): void {
    this.vehicleState.purchaseMonth = purchaseMonth;
    this.storage.updateCalculation();
  }
}
